import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button, Grid } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import ApplicationCard from '../../components/applicationCard/applicationCard';
import BackIcon from '../../images/dashboard/BackIcon.png';

import { useSelector } from 'react-redux';
import './parentCard.scss';
/**
 * ParentCard component displays hierarchical performance metrics and related statistics.
 * 
 * @component
 * @param {Object} props - React props
 * @param {Object} props.parentDetails - Parent details object containing performance data and hierarchy level.
 * @param {string} props.parentDetails.name - Name of the parent entity.
 * @param {number} props.parentDetails.level - Hierarchy level (3: CIRCLE, 4: DIVISION, 5: SUB-DIVISION).
 * @param {number} props.parentDetails.overallPerformance - Overall performance percentage.
 * @param {string} props.parentDetails.trendingIcon - URL of the trending icon image.
 * @param {Object} props.parentDetails.pieChart - Highcharts configuration for pie charts.
 * @param {Function} props.parentDetails.function - Function to handle navigation to the previous level.
 * @param {Array} props.parentDetails.customerServices - Array of customer service applications.
 * @param {Array} props.parentDetails.technicalCommercial - Array of technical & commercial loss details.
 * 
 * @returns {JSX.Element} React component rendering a parent performance card.
 */
const ParentCard = ({ parentDetails }) => {

    let { hierarchy } = useSelector((state) => state.auth)

    return (
        <Grid container padding={1} className='parent-container'>
            <Grid item className='top-content-item'>
                <Grid container spacing={2} className='top-content-container'>
                    <Grid item className='left-content-item'>
                        <Grid container spacing={2} className='left-content-container'>
                            <Grid item className='parent-name-item'>
                                <h3 className='parent-name'>
                                    {parentDetails.name} {parentDetails.level === 3 ? 'CIRCLE' : parentDetails.level === 4 ? 'DIVISION' : parentDetails.level === 5 ? 'SUB-DIVISION' : ''}
                                </h3>
                            </Grid>
                            <Grid item className='card-item'>
                                <div className='card-container-overall' style={{ backgroundColor: parentDetails.overallPerformance > 0 ? '#e11b3c' : '#019760' }}>
                                    <p className='card-text'>
                                        Overall <br /> Performance
                                    </p>
                                    <img src={parentDetails.trendingIcon} alt="trending" className='card-image' />
                                    <h2 className='percentage'>{parentDetails.overallPerformance ? Math.abs(parentDetails.overallPerformance) : ''}%</h2>
                                </div >
                            </Grid>
                            <Grid item className='card-item'>
                                <div className='card-container'>
                                    <p className='card-text'>
                                        New <br /> Connection
                                    </p>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={parentDetails.pieChart}
                                    />
                                </div >
                            </Grid>
                            <Grid item className='card-item'>
                                <div className='card-container'>
                                    <p className='card-text'>
                                        Defective <br /> Meters
                                    </p>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={parentDetails.pieChart}
                                    />
                                </div >
                            </Grid>
                            <Grid item className='card-item'>
                                <div className='card-container'>
                                    <p className='card-text'>
                                        T & D <br /> Losses
                                    </p>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={parentDetails.pieChart}
                                    />
                                </div >
                            </Grid>
                            <Grid item className='card-item'>
                                <div className='card-container'>
                                    <p className='card-text'>
                                        Recovery
                                    </p>
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={parentDetails.pieChart}
                                    />
                                </div >
                            </Grid>
                        </Grid>
                    </Grid>
                    {
                        hierarchy === 1 || hierarchy === 2 ?
                            parentDetails.level > 2 &&
                            <Grid item >
                                <img src={BackIcon} alt='back' onClick={() => parentDetails.function(parentDetails)} width='40' />
                            </Grid> : null
                    }
                    {
                        hierarchy === 3 ?
                            parentDetails.level > 3 &&
                            <Grid item >
                                <Button variant='contained' sx={{ backgroundImage: '#006ad1', boxShadow: 'none' }} onClick={() => parentDetails.function(parentDetails)}><ArrowBackIosNewIcon /> Back</Button>
                            </Grid> : null
                    }
                    {
                        hierarchy === 4 || hierarchy === 51 ?
                            parentDetails.level > 4 &&
                            <Grid item >
                                <Button variant='contained' sx={{ backgroundImage: '#006ad1', boxShadow: 'none' }} onClick={() => parentDetails.function(parentDetails)}><ArrowBackIosNewIcon /> Back</Button>
                            </Grid> : null
                    }
                    {
                        hierarchy === 52 ?
                            parentDetails.level > 5 &&
                            <Grid item >
                                <Button variant='contained' sx={{ backgroundImage: '#006ad1', boxShadow: 'none' }} onClick={() => parentDetails.function(parentDetails)}><ArrowBackIosNewIcon /> Back</Button>
                            </Grid> : null
                    }

                </Grid>
            </Grid>
            <Grid item className='bottom-cards-item'>
                <Grid container spacing={2} padding={1} className='bottom-cards-container'>
                    <Grid item lg={6} className='card-item'>
                        <div className='card-container'>
                            <h3 className='card-title'>Customer Services</h3>
                            <div className='card-content'>
                                {parentDetails.customerServices.map(item => {
                                    return <div onClick={() => item.function()}>
                                        <ApplicationCard applicationNameA={item.titleA} applicationNameB={item.titleB} totalApplications={item.total} pendingApplications={item.pending} applicationType={item.type} descriptiveText={item.descriptiveText} titleFontSize="1vw" />
                                    </div>
                                })}
                            </div>
                        </div>
                    </Grid>
                    <Grid item lg={6} className='card-item'>
                        <div className='card-container'>
                            <h3 className='card-title'>Technical & Commercial Losses</h3>
                            <div className='card-content'>
                                {parentDetails.technicalCommercial.map(item => {
                                    return <div onClick={() => item.function()}>
                                        <ApplicationCard applicationNameA={item.titleA} applicationNameB={item.titleB} percentage={item.value} applicationType={item.type} incDec={item.incDec} titleFontSize="1vw" />
                                    </div>
                                })}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ParentCard
